export default {
    replaceState: function (stateObj, title, url) {
        window.history.replaceState(stateObj, title, url);
    },
};
